import { render, staticRenderFns } from "./CargoLibraryImport.vue?vue&type=template&id=008cdbe2"
import script from "./CargoLibraryImport.vue?vue&type=script&lang=ts"
export * from "./CargoLibraryImport.vue?vue&type=script&lang=ts"
import style0 from "./CargoLibraryImport.vue?vue&type=style&index=0&id=008cdbe2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports